<div class="bonus-actions__cell">
  <button
    #trigger
    class="bonus-actions__trigger"
    [class.bonus-actions__trigger--open]="isOpen"
    type="button"
    aria-haspopup="menu"
    [attr.aria-expanded]="isOpen"
    [attr.aria-label]="
      'userlistBonusActions.trigger' | translate: { name: consultantName }
    "
    (click)="$event.stopPropagation(); onToggleClick(berater.id)"
  >
    <svg
      class="bonus-actions__trigger-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.9"
      stroke-linecap="round"
      aria-hidden="true"
    >
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  </button>

  @if (isOpen) {
    <!-- stopPropagation: die ganze Beraterkarte ist ein routerLink auf das Profil. -->
    <div
      class="bonus-actions__menu"
      role="menu"
      (click)="$event.stopPropagation()"
    >
      <button
        class="bonus-actions__item"
        type="button"
        role="menuitem"
        [routerLink]="['/berater', berater.id, 'text']"
        (click)="closeMenu.emit()"
      >
        {{ 'userlistBonusActions.button.onlyText' | translate }}
      </button>

      <button
        class="bonus-actions__item"
        type="button"
        role="menuitem"
        [routerLink]="['/zeugnis', berater.id]"
        (click)="closeMenu.emit()"
      >
        {{ 'userlistBonusActions.button.certificate' | translate }}
      </button>

      <p class="bonus-actions__note">
        {{ 'userlistBonusActions.hint' | translate }}
        <button
          class="bonus-actions__link"
          type="button"
          (click)="openProfile()"
        >
          {{ 'userlistBonusActions.hintLink' | translate }}
        </button>
      </p>
    </div>
  }
</div>
